import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { authService } from '@app/services';
import { routingService } from '@app/services';
import { resetState, resetSortingMenu, resetException } from '@app/store/actions';
import { setupIntercom, shutdownIntercom } from '@app/helpers';

interface IProps extends RouteProps {
    component: any;
    layout: any;
}

export const PrivateRoute = (props: IProps) => {
    const dispatch = useDispatch();
    const isSignedIn = authService.isSignedIn();
    let isRedirecting = false;

    const { component: Component, layout: Layout, ...rest } = props;

    dispatch(resetState());
    dispatch(resetException());
    dispatch(resetSortingMenu());

    useEffect(() => {
        if (isSignedIn) {
            setupIntercom(window);
        } else {
            shutdownIntercom(window);
        }
    }, [isSignedIn]);

    return (
        <Route
            {...rest}
            render={(props: any) => {
                return isSignedIn ? (
                    routingService.hasRoutePermission(props.location.pathname) ? (
                        <Layout>
                            <Component key={Math.random() * 1000} {...props} />
                        </Layout>
                    ) : (
                        <Redirect to={{ pathname: '/apps', state: { from: props.location } }} />
                    )
                ) : isRedirecting ? null : (
                    <Redirect to={{ pathname: '/signin', state: { from: props.location } }} />
                );
            }}
        />
    );
};
